import _plugin_vue_export_helper_default from "../_virtual/_plugin-vue_export-helper.js";
import PromptForm_vue_vue_type_script_setup_true_lang_default from "./PromptForm.vue.script.js";
/* empty css                         */
//#region src/views/PromptForm.vue
var PromptForm_default = /*#__PURE__*/ _plugin_vue_export_helper_default(PromptForm_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-3a0f1d21"]]);
//#endregion
export { PromptForm_default as default };

//# sourceMappingURL=PromptForm.vue.js.map